query LpUserBalance {
  lpUserBalance {
    olpBalance {
      amount
    }
    xpBalance {
      amount
    }
  }
}
